<template>
  <div class="assembly-sort-goods">
    <p class="ttile">
      搭销商品
      <span
        >说明：可直接添加搭销商品，商品价格同线上页面价格，参与活动商品同步活动展示样式.
      </span>
    </p>
    <div class="set-content">
      <div class="set-item add-goods">
        <p class="title">搭销分组管理</p>
        <p class="dec">最多添加100个搭销商品，拖拽可排序</p>

        <GoodsControl v-model="curComponent.sorts" :maxLength="6" />
      </div>

      <div class="set-item" style="margin-top: 30px;">
        <p class="title">分组样式</p>
        <SpPickerColor
          v-model="curComponent.sortStyles.backgroundColor"
          :isGradient="true"
          label="背景颜色"
          defaultColor="#ffffff"
          style="margin-bottom: 20px;"
        />
        <SpPickerColor
          v-model="curComponent.sortStyles.titleColor"
          defaultColor="#FF0000"
          label="分组标题颜色"
        />
      </div>

      <div class="set-item" style="margin-top: 30px;">
        <p class="title">分组列表样式</p>
        <TypeGroup v-model="curComponent.type" :options="typeOptions" />
      </div>

      <div class="set-item basic-set">
        <p class="title">组合商品样式基础设置</p>
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleAssemblyTitle"
          label="搭销组合标题"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleComment"
          label="药师点评"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleGoodsName"
          label="商品名称"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleSpec"
          label="商品规格"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleMarketPrice"
          label="商品原价"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpRadio
          v-model="curComponent.styleBasicSet.visibleCart"
          label="购物车"
          :options="[
            { label: '显示', value: true },
            { label: '不显示', value: false }
          ]"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.backgroundColor"
          :isGradient="true"
          label="组件背景颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.assemblyTitleColor"
          defaultColor="#000000"
          label="搭销组合标题颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.commentColor"
          defaultColor="#999"
          label="药师点评颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.goodsNameColor"
          defaultColor="#000000"
          label="商品名称颜色"
        />
        <SpPickerColor
          v-model="curComponent.styleBasicSet.goodsPriceColor"
          defaultColor="#fe2e57"
          label="商品价格颜色"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.goodsRadius"
          label="商品圆角值"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.assemblyRadius"
          label="组合圆角值"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.pageMx"
          label="页面边距"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.assemblyMargin"
          label="组合间距"
        />
        <SpSlider
          v-model="curComponent.styleBasicSet.pageMb"
          label="页面底部边距"
        />
      </div>
    </div>
  </div>
</template>

<script>
import TypeGroup from "./components/TypeGroup";

import typeOptions from "./typeOptions";
import SpRadio from "../../../components/SpRadio";
import SpSlider from "../../../components/SpSlider";
import GoodsControl from "./components/GoodsControl";
import SpPickerColor from "../../../components/SpPickerColor";
export default {
  components: {
    SpRadio,
    SpSlider,
    TypeGroup,
    GoodsControl,
    SpPickerColor
  },
  inject: ["control"],
  data() {
    return {
      typeOptions: Object.freeze(typeOptions),
      curIndex: 1,
      maxGoodsCount: 100
    };
  },
  computed: {
    info: {
      get() {
        // 没有就创建一项
        if (!this.curComponent.imgs[this.curIndex]) {
          const initParams = {
            path: "",
            imgUrl: ""
          };
          this.$set(this.control.curComponent.imgs, this.curIndex, initParams);
        }
        return this.curComponent.imgs[this.curIndex];
      },
      set(val) {
        this.$set(this.control.curComponent.imgs, this.curIndex, val);
      }
    },
    curComponent: {
      get() {
        return this.control.curComponent;
      },
      set(val) {
        this.control.curComponent = val;
      }
    },
    typeCount() {
      const count = this.typeOptions.find(
        item => item.type === this.curComponent.type
      ).count;
      this.curComponent.count = count;
      return count;
    }
  }
};
</script>

<style lang="less" scoped>
.assembly-sort-goods {
  .ttile {
    padding: 22px 24px 20px 24px;
    font-size: 16px;
    border-bottom: 1px solid #eee;
    font-weight: 500;
    span {
      font-size: 10px;
      color: #999999;
      padding-left: 10px;
    }
  }
  > .set-content {
    padding-top: 15px;
    padding: 20px 24px;
    > .set-item {
      > .title {
        font-size: 14px;
        font-weight: 500;
        margin-bottom: 12px;
      }
      > .dec {
        font-size: 12px;
        color: #999999;
        font-weight: 400;
        margin-bottom: 20px;
      }
      > .select-view {
        margin-top: 12px;
        > span {
          font-size: 12px;
          font-weight: 400;
        }
        > span:first-child {
          color: #999999;
        }
        > span:last-child {
          color: #333333;
          padding-left: 10px;
        }
      }
    }

    > .basic-set {
      margin-top: 30px;
      > .radius-set-title {
        display: flex;
        align-items: center;
        background: #f7f8fa;
        border-radius: 4px;
        padding: 14px 12px 14px 16px;
        margin-bottom: 20px;
        > p {
          font-size: 12px;
          margin-right: 10px;
        }
        /deep/ .el-input {
          flex: 1;
          .el-input__inner {
            height: 30px;
            line-height: 30px;
            padding: 0 10px;
            font-size: 12px;
            color: #000000;
            &::placeholder {
              color: #999999;
            }
          }
        }
      }
      /deep/ .sp-radio {
        margin-bottom: 20px;
      }
      /deep/.picker-color {
        margin-bottom: 20px;
      }
      /deep/.slider-content {
        margin-bottom: 20px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/myviews/shoppMall/activityPageSet/fullPlatformSetQuery/lowCode/custom-component/productComponents/AssemblySortGoods/Attr.vue